<template>
    <div>
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <router-view></router-view>
                </div>
            </div>
        </div>
    </div>
</template>
